import React, { useEffect, useState } from "react";
import FormField from "../FormField";
import { toast } from "react-toastify";

const EditAdminForm = (props) => {
  const [role, setRole] = useState("");
  const { admin } = props;

  const handleRole = (event) => {
    setRole(event.target.value);
  };

  const handleEditAdmin = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    var object = {};
    formData.forEach(function (value, key) {
      object[key] = value;
    });
    object.role = role;
    object.admin = admin._id;
    const response = null;
    if (response) {
      toast.success("Admin update successfully!");
      props.getAdmins();
      window.location.reload();
    }
  };

  return (
    <div
      className="modal fade"
      id="editAdminsModal"
      aria-hidden="true"
      aria-labelledby="exampleModalToggleLabel"
      tabindex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
              Edit Admin
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleEditAdmin}>
              <FormField
                label="Name"
                type="text"
                placeholder="Name"
                defaultValue={admin?.name}
                name="name"
              />
              <FormField
                label="Email"
                type="text"
                placeholder="Region"
                defaultValue={admin?.email}
                name="email"
              />
              <FormField
                label="Phone Number"
                type="text"
                placeholder="Phone Number"
                defaultValue="1234567890"
                name="phoneNumber"
              />
              <FormField
                label="Password"
                type="password"
                defaultValue="123123"
                placeholder="Password"
                name="password"
              />
              <div className="mb-3">
                <label for="recipient-name" className="col-form-label">
                  Role
                </label>
                <div className="role">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={handleRole}
                  >
                    <option value="1">Admin</option>
                    <option value="2">Super Admin</option>
                  </select>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  id="edit-admin-button"
                  className="btn-model"
                  // data-bs-target="#exampleModalToggle2"
                  // data-bs-toggle="modal"
                  type="submit"
                >
                  Edit Admin
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAdminForm;
